var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c(_vm.layout,{tag:"component"},[_c('router-view',{attrs:{"slot":"subnav","name":"subnav"},slot:"subnav"}),_c('router-view',{attrs:{"slot":"default"},slot:"default"})],1):_c('loading-app')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }